import * as XLSX from 'xlsx';
import moment from 'moment';

export const exportToExcel = (excelData, columnWidths, sheetName, fileNamePrefix) => {
  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const colWidths = [];
  excelData.forEach(row => {
    Object.values(row).forEach((value, index) => {
      const cellLength = value ? value.toString().length : 0;
      colWidths[index] = Math.max(colWidths[index] || 10, cellLength + 2);
    });
  });

  worksheet['!cols'] = colWidths.map(width => ({ wch: width }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  if (columnWidths && columnWidths.length > 0) {
    worksheet['!cols'] = columnWidths;
  }

  const fileName = `${fileNamePrefix}_${moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};
